import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "image-placeholder",
  role: "button",
  tabindex: "0",
  "aria-label": "Загрузить фото"
}
const _hoisted_2 = { class: "placeholder-inner" }
const _hoisted_3 = { class: "placeholder-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_file_uploader = _resolveComponent("app-file-uploader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("svg", {
        class: "placeholder-icon",
        width: "48",
        height: "48",
        viewBox: "0 0 24 24",
        "aria-hidden": "true"
      }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M5 20h14V8l-4-4H5v16zm2-9l2.5 3 3.5-4.5L17 17H7l0-6z"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t('photoNotUploaded')), 1),
      _createVNode(_component_app_file_uploader, {
        "is-show-sign": false,
        onSelect: _ctx.onFileSelected
      }, null, 8, ["onSelect"])
    ])
  ]))
}